<template>
  <div class="clientTransactionDetails">
    <div>
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="form.account" placeholder="交易账号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.product" placeholder="交易产品"></el-input>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="form.startTime"
            type="datetime"
            placeholder="开始时间"
          ></el-date-picker>&nbsp;至&nbsp;
          <el-date-picker
            v-model="form.endTime"
            type="datetime"
            placeholder="结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.orderId" placeholder="单号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="form.tradeDirection" placeholder="请选择买卖方向">
            <el-option
              v-for="item in form.tradeDirectionData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="form.agent" placeholder="请选择代理">
            <el-option
              v-for="item in form.agentData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.directAccount" placeholder="直接推荐人"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.indirectAccount" placeholder="间接推荐人"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small">{{$t('common.reset')}}</el-button>
          <el-button type="primary" size="small">{{$t('common.search')}}</el-button>
          <el-button type="primary" size="small">{{$t('common.export')}}</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tableData" style="width: 100%" max-height="800px" border>
        <el-table-column :prop="item.id" :label="item.name" v-for="item in tableNav"></el-table-column>
      </el-table>
      <div class="block flexEnd" v-if="totalNum>0">
        <el-pagination
          background
          small
          @current-change="changeCurrentTradeDetails"
          :current-page="currentPage"
          :page-size="pageSize"
          :pager-count="10"
          layout="total, prev, pager, next, jumper"
          :total="totalNum">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import Util from '@/utils/IM/tradeDataUtil'
  import nationalMarketing from '@/api/nationalMarketing/nationalMarketing'

  export default {
    name: 'clientTransactionDetails',
    data() {
      return {
        form: {
          account: '',
          product: '',
          startTime: new Date(),
          endTime: new Date(),
          orderId: '',
          tradeDirection: '',
          tradeDirectionData: [],
          agent: '',
          agentData: [],
          directAccount: '',
          indirectAccount: ''
        },
        tableNav: [
          { name: '交易账号', id: 'account' },
          { name: '交易平台', id: 'tradePlatform' },
          { name: '交易产品', id: 'productCode' },
          { name: '单号', id: 'orderId' },
          { name: '下单时间', id: 'orderTime' },
          { name: '成交价格', id: 'orderPrice' },
          { name: '买入/卖出', id: 'tradeDirection' },
          { name: '下单金额', id: 'amount' },
          { name: '结算时间', id: 'closeTime' },
          { name: '结算价格', id: 'closePrice' },
          { name: '盈亏', id: 'orderProfit' },
          { name: '一级代理', id: 'oneAgent' },
          { name: '一级代理分成金额', id: 'oneAgentAmount' },
          { name: '二级代理', id: 'twoAgent' },
          { name: '二级代理分成金额', id: 'twoAgentAmount' },
          { name: '三级代理', id: 'threeAgent' },
          { name: '三级代理分成金额', id: 'threeAgentAmount' },
          { name: '直接推荐人', id: 'directAccount' },
          { name: '直接推荐人分成金额', id: 'directAccountAmount' },
          { name: '间接推荐人', id: 'indirectAccount' },
          { name: '间接推荐人分成金额', id: 'indirectAccountAmount' }
        ],
        tableData: [],
        totalNum: 0,  //当前资源条数
        currentPage: 1,  //当前页数
        pageSize: 10 //当前页条数数
      }
    },
    methods: {
      getAgentListData(data) {
        nationalMarketing.queryOrderListPage(data).then(res => {
          if (res.code == 0) {
            if (res.result) {
              let data = res.result.list
              for (const i in data) {
                if (Util.isNotEmpty(data[i].orderTime)) {
                  data[i].orderTime = new Date(data[i].orderTime).format('Y-MM-dd hh:mm:ss')
                }
                if (Util.isNotEmpty(data[i].closeTime)) {
                  data[i].closeTime = new Date(data[i].closeTime).format('Y-MM-dd hh:mm:ss')
                }
              }
              this.tableData = data
              this.totalNum = res.result.total
            }
          } else {
            this.$message.error(res.message)
          }
        })
      },
      initTradeDetailsData() {
        let data = {
          pageNum: this.currentPage
        }
        this.getAgentListData(data)
      },
      changeCurrentTradeDetails(val) {
        this.currentPage = val
        let data = {
          pageNum: val
        }
        this.getAgentListData(data)
      }
    },
    mounted() {
      this.initTradeDetailsData()
    }
  }
</script>

<style lang="scss" scoped>
  .clientTransactionDetails {
    margin: 20px;

    .flexEnd {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 20px;
    }
  }
</style>
